import { Span } from '@sentry/tracing';
import { timer } from './timer.fn';

export function toBlob(
  canvas: HTMLCanvasElement,
  mime = 'image/jpeg',
  quality = 1,
  span: Span | undefined
) {
  const s = span?.startChild({
    op: 'toBlob',
  });

  return timer(
    'toBlob',
    () =>
      new Promise<Blob | null>((resolve) => {
        canvas.toBlob(
          (blob) => {
            s?.finish();
            resolve(blob);
          },
          mime,
          quality
        );
      })
  );
}
